import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { Bullets as i } from "./Bullets.js";
import { TIPS_LENGTH as l } from "../constants/tips.js";
const a = ({
  step: t,
  handleBackStep: r,
  handleNextStep: n
}) => /* @__PURE__ */ e("footer", { children: [
  /* @__PURE__ */ o("button", { onClick: r, className: "back-button", children: "Voltar" }),
  /* @__PURE__ */ o(i, { step: t }),
  /* @__PURE__ */ o("button", { onClick: n, className: "confirm-button", children: t === l ? "Legal, Entendi" : "Próximo" })
] });
export {
  a as Footer
};
